// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e97f887","950":"c1d9d76e"}[chunkId] + ".chunk.js";
};